import { BRAND } from "../risikoanalyseStep/tokens";
import type { EaStepKind } from "./types";

/** Schritt-Illustrationen der Ertragsausfall-Maske, im Stil der übrigen Vertragsmasken. */
const Wrap = ({ children }: { children: React.ReactNode }) => (
  <svg width={140} height={96} viewBox="0 0 140 96" fill="none" aria-hidden="true">
    {children}
  </svg>
);

const Grunddaten = () => (
  <Wrap>
    <rect x="22" y="16" width="60" height="64" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <path d="M30 30h44M30 40h34M30 50h40M30 60h24" stroke={BRAND.muted} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M92 68l14-16 10 10 12-22" stroke={BRAND.pillarOrange} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <circle cx="128" cy="40" r="4" fill={BRAND.gold} />
  </Wrap>
);

const Umfeld = () => (
  <Wrap>
    <rect x="16" y="42" width="34" height="38" rx="3" fill={BRAND.purple} />
    <rect x="56" y="26" width="34" height="54" rx="3" fill={BRAND.pillarBlue} />
    <rect x="96" y="50" width="30" height="30" rx="3" fill={BRAND.gold} />
    <path d="M50 62h6M90 62h6" stroke={BRAND.ink} strokeWidth="2" strokeDasharray="3 3" />
  </Wrap>
);

const Bemessung = () => (
  <Wrap>
    <rect x="14" y="26" width="112" height="46" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <text x="40" y="57" fontFamily="Arial" fontSize="22" textAnchor="middle" fill={BRAND.purple} fontWeight="700">€</text>
    <path d="M64 62V38M78 62V44M92 62V34M106 62V48" stroke={BRAND.pillarGreen} strokeWidth="5" strokeLinecap="round" />
  </Wrap>
);

const Limits = () => (
  <Wrap>
    <rect x="18" y="30" width="104" height="36" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <rect x="18" y="30" width="66" height="36" rx="4" fill={BRAND.pillarGreen} opacity="0.8" />
    <path d="M96 20v56" stroke={BRAND.gold} strokeWidth="4" strokeLinecap="round" />
    <text x="96" y="88" fontFamily="Arial" fontSize="11" textAnchor="middle" fill={BRAND.muted}>Limit</text>
  </Wrap>
);

const Haftzeit = () => (
  <Wrap>
    <circle cx="52" cy="48" r="28" fill="none" stroke={BRAND.purple} strokeWidth="3" />
    <path d="M52 30v20l14 8" stroke={BRAND.ink} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <path d="M90 62h34" stroke={BRAND.gold} strokeWidth="4" strokeLinecap="round" />
    <path d="M90 40h20" stroke={BRAND.pillarOrange} strokeWidth="4" strokeLinecap="round" />
  </Wrap>
);

const Gefahren = () => (
  <Wrap>
    <path d="M70 12l34 13v23c0 19-15 34-34 40-19-6-34-21-34-40V25l34-13z" fill={BRAND.pillarOrange} />
    <path d="M60 48l8 9 20-21" stroke={BRAND.white} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </Wrap>
);

const Deckungen = () => (
  <Wrap>
    <rect x="18" y="20" width="46" height="26" rx="4" fill={BRAND.pillarGreen} />
    <rect x="76" y="20" width="46" height="26" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <rect x="18" y="54" width="46" height="26" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <rect x="76" y="54" width="46" height="26" rx="4" fill={BRAND.gold} />
  </Wrap>
);

const Klauseln = () => (
  <Wrap>
    <rect x="26" y="14" width="72" height="68" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <path d="M36 30h52M36 42h40M36 54h48M36 66h30" stroke={BRAND.muted} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="104" cy="70" r="16" fill={BRAND.pillarBlack} />
    <path d="M98 70h12" stroke={BRAND.white} strokeWidth="2.6" strokeLinecap="round" />
  </Wrap>
);

const Dokumentation = () => (
  <Wrap>
    <rect x="24" y="18" width="56" height="62" rx="4" fill={BRAND.white} stroke={BRAND.purple} strokeWidth="2" />
    <rect x="44" y="10" width="56" height="62" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <path d="M54 26h36M54 38h28M54 50h32" stroke={BRAND.muted} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="106" cy="72" r="14" fill={BRAND.pillarGreen} />
    <path d="M100 72l4 4 8-8" stroke={BRAND.white} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </Wrap>
);

const Sollwerte = () => (
  <Wrap>
    <rect x="16" y="24" width="46" height="50" rx="4" fill={BRAND.bg} stroke={BRAND.pillarBlue} strokeWidth="2" />
    <rect x="78" y="24" width="46" height="50" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <path d="M64 42h12M64 56h12" stroke={BRAND.gold} strokeWidth="3" strokeLinecap="round" />
    <text x="39" y="18" fontFamily="Arial" fontSize="10" textAnchor="middle" fill={BRAND.muted}>Soll</text>
    <text x="101" y="18" fontFamily="Arial" fontSize="10" textAnchor="middle" fill={BRAND.muted}>Ist</text>
  </Wrap>
);

const Ergebnis = () => (
  <Wrap>
    <circle cx="70" cy="48" r="30" fill="none" stroke={BRAND.border} strokeWidth="8" />
    <path d="M70 18a30 30 0 0 1 26 45" stroke={BRAND.pillarGreen} strokeWidth="8" strokeLinecap="round" fill="none" />
    <path d="M58 48l9 10 18-20" stroke={BRAND.ink} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </Wrap>
);

const StepHero = ({ kind }: { kind: EaStepKind }) => {
  switch (kind) {
    case "grunddaten":
      return <Grunddaten />;
    case "umfeld":
      return <Umfeld />;
    case "bemessung":
      return <Bemessung />;
    case "limits":
      return <Limits />;
    case "haftzeit":
      return <Haftzeit />;
    case "gefahren":
      return <Gefahren />;
    case "deckungen":
      return <Deckungen />;
    case "klauseln":
      return <Klauseln />;
    case "dokumentation":
      return <Dokumentation />;
    case "sollwerte":
      return <Sollwerte />;
    case "ergebnis":
      return <Ergebnis />;
    default:
      return <Grunddaten />;
  }
};

export default StepHero;
